import type { AuthenticateProps } from '@bear-auth/core';

import type { AuthUser } from '../schemas/oauth';

export const DEMO_USERS = [
    {
        id: 'SB.01',
        email: 'john.doe@passwd.team',
        name: 'John Doe',
        isAdmin: false,
        domain: '__demo__',
        notifications: [],
    },
    {
        id: 'SB.02',
        email: 'jenna.burns@passwd.team',
        name: 'Jenna Burns',
        isAdmin: false,
        domain: '__demo__',
        notifications: [],
    },
    {
        id: 'SB.03',
        email: 'alice.kaestner@passwd.team',
        name: 'Alice Kaestner',
        isAdmin: false,
        domain: '__demo__',
        notifications: [],
    },
    {
        id: 'SB.04',
        email: 'bob.waddy@passwd.team',
        name: 'Bob Waddy',
        isAdmin: false,
        domain: '__demo__',
        notifications: [],
    },
    {
        id: 'SB.05',
        email: 'rick.sandmann@passwd.team',
        name: 'Rick Sandman',
        isAdmin: false,
        domain: '__demo__',
        notifications: [],
    },
    {
        id: 'SB.06',
        email: 'george.saunders@passwd.team',
        name: 'George Saunders',
        isAdmin: true,
        domain: '__demo__',
        notifications: [],
    },
    {
        id: 'SB.07',
        email: 'admin@passwd.team',
        name: 'Admin',
        isAdmin: true,
        domain: '__demo__',
        notifications: [],
    },
] as const satisfies AuthUser[];

export const DEFAULT_DEMO_USER_ID: (typeof DEMO_USERS)[number]['id'] = 'SB.07';

export const DEMO_USERS_WITH_CREDENTIALS = DEMO_USERS.map(
    user =>
        ({
            authInfo: user,
            accessToken: user.id,
            expiration: new Date(Date.now() + 365 * 24 * 60 * 60).toISOString(),
        }) satisfies AuthenticateProps<AuthUser>,
);
